import { apiFetch } from '../helpers/api-fetch';
import { Reminder } from '../models/reminder';

export class ReminderService {

    static readonly APIUrl = process.env.REACT_APP_API_URL as string + "/api/reminders"; // API server domain

    // Get all reminders from user
    public static async getUserReminders(userId: number) {
        const res = await apiFetch(`${this.APIUrl}/GetUserRemindersForEdit/${userId}`, {
            method: 'GET'
        });
        return Promise.resolve(res);
    }

    // Get all reminder log entries for user
    public static async getUserRemindersLog(userId: number) {
        const res = await apiFetch(`${this.APIUrl}/GetUserRemindersLog/${userId}`, {
            method: 'GET'
        });
        return Promise.resolve(res);
    }

    // Get by id
    public static async getById(id: string) {
        const res = await apiFetch(`${this.APIUrl}/${id}`, {
            method: 'GET'
        });
        return Promise.resolve(res);
    }

    // create or update data
    public static createOrUpdate(task: Reminder) {
        
        return apiFetch(`${this.APIUrl}`, {
            method: 'POST',
            body: JSON.stringify(task)
        }).then(res => {
            return Promise.resolve(res);
        });
    }

    // Delete by id
    public static async deleteById(id: number | undefined) {
        const res = await apiFetch(`${this.APIUrl}/${id}`, {
            method: 'DELETE'
        });
        return Promise.resolve(res);
    }


}